// extracted by extract-css-chunks-webpack-plugin
module.exports = {"section":"award-summary-section__section--3_7rC"};